export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const eur2 = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export const pct = (n) => `${(n || 0).toFixed(1)} %`;

export const margeText = (t) =>
  t >= 35 ? "text-emerald-400" : t >= 20 ? "text-amber-400" : "text-red-400";

export const margeBadge = (t) =>
  t >= 35
    ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/20"
    : t >= 20
    ? "bg-amber-500/10 text-amber-400 border-amber-500/20"
    : "bg-red-500/10 text-red-400 border-red-500/20";

export const STATUT_DEVIS = {
  "Brouillon": "bg-slate-500/10 text-slate-300 border-slate-500/30",
  "Envoyé": "bg-sky-500/10 text-sky-400 border-sky-500/30",
  "Négociation": "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "Validé / Accepté": "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  "Refusé": "bg-red-500/10 text-red-400 border-red-500/30",
};

export const STATUT_CHANTIER = {
  "En préparation": "bg-slate-500/10 text-slate-300 border-slate-500/30",
  "En cours": "bg-sky-500/10 text-sky-400 border-sky-500/30",
  "En réception": "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "Clôturé": "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
};

export const FAMILLES = [
  "Gros Œuvre",
  "Cuisine",
  "Menuiserie",
  "Salle de Bain",
  "Revêtements de Sol",
  "Revêtements Muraux",
  "Chauffage",
  "Poêle à Bois & Granulés",
  "Climatisation",
];

export const UNITES = ["m²", "ml", "m³", "h", "j (jour)", "forfait", "u (pièce)"];

export const FAMILLE_COLOR = {
  "Gros Œuvre": "#F59E0B",
  "Cuisine": "#38BDF8",
  "Menuiserie": "#A78BFA",
  "Salle de Bain": "#22D3EE",
  "Revêtements de Sol": "#F472B6",
  "Revêtements Muraux": "#FB923C",
  "Chauffage": "#EF4444",
  "Poêle à Bois & Granulés": "#F97316",
  "Climatisation": "#10B981",
};

const FALLBACK_PALETTE = ["#F59E0B", "#38BDF8", "#A78BFA", "#22D3EE", "#F472B6", "#FB923C", "#EF4444", "#F97316", "#10B981", "#84CC16"];

export function famColor(nom, familles) {
  if (familles && familles.length) {
    const f = familles.find((x) => x.nom === nom);
    if (f && f.couleur) return f.couleur;
  }
  if (FAMILLE_COLOR[nom]) return FAMILLE_COLOR[nom];
  let h = 0;
  for (let i = 0; i < (nom || "").length; i++) h = (h * 31 + nom.charCodeAt(i)) >>> 0;
  return FALLBACK_PALETTE[h % FALLBACK_PALETTE.length];
}
